// extracted by mini-css-extract-plugin
export var distancecontainer = "SchoolLocationFilters-module--distancecontainer--970ac";
export var distancecontrols = "SchoolLocationFilters-module--distancecontrols--ce79f";
export var distancerange = "SchoolLocationFilters-module--distancerange--25487";
export var distanceselect = "SchoolLocationFilters-module--distanceselect--973c4";
export var filters = "SchoolLocationFilters-module--filters--d8254";
export var label = "SchoolLocationFilters-module--label--93725";
export var searchinput = "SchoolLocationFilters-module--searchinput--1e850";
export var title = "SchoolLocationFilters-module--title--e4157";
export var viewmore = "SchoolLocationFilters-module--viewmore--e45d3";